import { Box, Button, Container, Divider, Grid, Paper, Typography } from '@mui/material';
import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Payment } from '@mui/icons-material';
import PaymentVendors from '@acorn-portal/shared/src/components/vendor/PaymentVendors';
import { useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';
import { ROUTE_PATHS } from '@acorn-portal/shared/src/utils/Routes';
import PaymentScheduleTable from '@acorn-portal/shared/src/components/display/payment-schedule-table';

const OverDueInstallmentPlan: FC = () => {
	const payNowDetails = useAppSelector((redux) => redux.payNow);
	const navigate = useNavigate();

	const handleSubmit = () => {
		navigate(ROUTE_PATHS.payNowSPDirectPayment);
	};

	useEffect(() => {
		if (!payNowDetails.details) {
			navigate(ROUTE_PATHS.home);
		}
	}, []);

	const { details } = payNowDetails;

	return (
		<Paper
			elevation={1}
			sx={{
				margin: 1.5,
				borderRadius: '8px',
				paddingBottom: 3,
			}}
		>
			<Container maxWidth='sm'>
				<Box sx={{ padding: 3 }} />
				<Typography
					variant='h4'
					color='secondary'
					component='h4'
					gutterBottom
					sx={{ textAlign: 'center', paddingBottom: 2 }}
				>
					Your Instalment Plan
				</Typography>
				<PaymentScheduleTable splitPaymentPlans={details?.splitPaymentPlans} />
				<Divider sx={{ mt: 4 }} />
				<Box mt={4} sx={{ paddingBottom: 2 }}>
					<Typography mt={2}>
						If you would like to pay your outstanding missed payment then please click the button below. Once your
						payment has been made we will continue to collect any future instalments as per your original payment plan
						automatically.
					</Typography>
					<Typography color='error' mt={2}>
						*Please note - The debit\credit card used to make your payment will be used for all future weekly
						instalments on this payment plan*
					</Typography>
				</Box>

				<Grid size={{ xs: 12, sm: 6 }}>
					<Button
						variant='contained'
						fullWidth
						color='secondary'
						type='button'
						onClick={handleSubmit}
						startIcon={<Payment />}
						size='large'
					>
						Proceed To Payment
					</Button>
				</Grid>
				<PaymentVendors />
			</Container>
		</Paper>
	);
};

export default OverDueInstallmentPlan;
